import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const CTASection = () => {
  return (
    <section className="relative text-white py-24 overflow-hidden" style={{
      background: `linear-gradient(135deg, 
        rgba(17, 24, 39, 1) 0%, 
        rgba(217, 59, 52, 0.98) 30%, 
        rgba(155, 142, 86, 0.98) 70%, 
        rgba(17, 24, 39, 1) 100%)`
    }}>
      {/* Enhanced Background Elements with Increased Opacity */}
      <div className="absolute inset-0">
        <div className="absolute inset-0" style={{
          background: `linear-gradient(90deg, 
            rgba(217, 59, 52, 0.4) 0%, 
            rgba(155, 142, 86, 0.35) 50%, 
            rgba(255, 215, 0, 0.4) 100%)`
        }}></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 20% 80%, rgba(217, 59, 52, 0.4) 0%, transparent 50%),
                           radial-gradient(circle at 80% 20%, rgba(155, 142, 86, 0.4) 0%, transparent 50%),
                           radial-gradient(circle at 40% 40%, rgba(255, 215, 0, 0.35) 0%, transparent 30%)`
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Enhanced Main CTA with Increased Opacity */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-4 backdrop-blur-sm px-8 py-4 rounded-full font-bold mb-8 border" style={{
            background: `linear-gradient(135deg, rgba(217, 59, 52, 0.7) 0%, rgba(155, 142, 86, 0.7) 100%)`,
            color: '#FFD700',
            borderColor: 'rgba(217, 59, 52, 0.8)'
          }}>
            <Icon name="Target" size={24} />
            <span>Concrétisons Votre Vision Ensemble</span>
          </div>
          
          <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight">
            Transformons Ensemble Votre 
            <span className="text-transparent bg-clip-text block mt-2" style={{
              background: `linear-gradient(135deg, #D93B34 0%, #9B8E56 50%, #FFD700 100%)`,
              WebkitBackgroundClip: 'text'
            }}>
              Vision Stratégique
            </span>
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-5xl mx-auto leading-relaxed">
            Rejoignez les entreprises leaders qui transforment leurs défis en opportunités de croissance durable avec 
            <span className="font-bold" style={{color: '#FFD700'}}> le partenaire stratégique de référence</span> pour l'excellence et l'innovation.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-8 justify-center mb-16">
            <Button
              variant="default"
              size="lg"
              className="text-white px-12 py-6 rounded-2xl font-bold text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl border"
              style={{
                background: `linear-gradient(135deg, #D93B34 0%, #9B8E56 50%, #D93B34 100%)`,
                borderColor: 'rgba(217, 59, 52, 0.6)'
              }}
            >
              <Icon name="MessageSquare" size={28} className="mr-4" />
              Consultation Vision Stratégique
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              className="border-2 px-12 py-6 rounded-2xl font-bold text-xl transition-all duration-300 backdrop-blur-sm"
              style={{
                borderColor: 'rgba(255, 215, 0, 0.6)',
                color: '#FFD700',
                backgroundColor: 'rgba(255, 215, 0, 0.2)'
              }}
            >
              <Icon name="Target" size={28} className="mr-4" />
              Évaluation Partenariale
            </Button>
          </div>
        </div>

        {/* Enhanced Vision Implementation Services with Increased Background Opacity */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {[
            {
              icon: "Search",
              title: "Diagnostic Vision 360°",
              description: "Évaluation approfondie de votre maturité organisationnelle et identification stratégique des leviers de transformation digitale.",
              features: ["Audit stratégique complet", "Analyse des enjeux business", "Potentiel d'amélioration", "Benchmarking sectoriel"],
              color: `linear-gradient(135deg, #D93B34 0%, #9B8E56 100%)`
            },
            {
              icon: "Compass",
              title: "Roadmap Stratégique",
              description: "Co-création d'une feuille de route personnalisée alignée sur votre vision et vos objectifs spécifiques d'excellence.",
              features: ["Planification sur-mesure", "Jalons mesurables", "Gouvernance partenariale", "KPI stratégiques"],
              color: `linear-gradient(135deg, #9B8E56 0%, #FFD700 100%)`
            },
            {
              icon: "Rocket",
              title: "Mise en Œuvre Agile",
              description: "Implémentation collaborative avec méthodologies agiles et ajustements en temps réel pour garantir le succès durable.",
              features: ["Approche itérative", "Formation intégrée", "Support continu", "Optimisation temps réel"],
              color: `linear-gradient(135deg, #FFD700 0%, #D93B34 100%)`
            },
            {
              icon: "Trophy",
              title: "Excellence Durable",
              description: "Pérennisation des acquis et amélioration continue pour maintenir l'avantage concurrentiel sur le long terme.",
              features: ["Suivi des performances", "Optimisation continue", "Innovation proactive", "Accompagnement évolutif"],
              color: `linear-gradient(135deg, #D93B34 0%, #FFD700 100%)`
            }
          ]?.map((service, index) => (
            <div key={index} className="group">
              <div className="backdrop-blur-sm rounded-3xl p-8 border transition-all duration-500 hover:transform hover:scale-105 h-full" style={{
                background: 'rgba(0, 0, 0, 0.4)',
                borderColor: 'rgba(255, 255, 255, 0.4)'
              }}>
                <div className="w-20 h-20 rounded-2xl flex items-center justify-center mb-8 shadow-lg group-hover:scale-110 transition-transform" style={{
                  background: service?.color
                }}>
                  <Icon name={service?.icon} size={40} className="text-white" />
                </div>
                
                <h3 className="text-xl font-bold mb-6 text-white">{service?.title}</h3>
                
                <p className="text-gray-200 text-sm mb-8 leading-relaxed">
                  {service?.description}
                </p>
                
                <ul className="space-y-3">
                  {service?.features?.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-xs text-gray-300">
                      <Icon name="CheckCircle" size={16} className="mr-3" style={{color: '#9ACD32'}} />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Enhanced Partnership Benefits with Increased Background Opacity */}
        <div className="backdrop-blur-sm rounded-[3rem] p-12 md:p-16 border mb-20" style={{
          background: 'rgba(0, 0, 0, 0.35)',
          borderColor: 'rgba(255, 255, 255, 0.4)'
        }}>
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-16">
            Pourquoi Choisir CRF PERFECTION comme 
            <span className="text-transparent bg-clip-text block mt-2" style={{
              background: `linear-gradient(135deg, #FFD700 0%, #D93B34 100%)`,
              WebkitBackgroundClip: 'text'
            }}>
              Partenaire Vision Stratégique ?
            </span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center group">
              <div className="rounded-full p-8 mb-8 w-fit mx-auto shadow-2xl group-hover:scale-110 transition-transform" style={{
                background: `linear-gradient(135deg, #FFD700 0%, #D93B34 100%)`
              }}>
                <Icon name="Award" size={48} className="text-white" />
              </div>
              <h4 className="text-2xl font-bold mb-6">18+ Années d'Excellence Prouvée</h4>
              <p className="text-gray-200 leading-relaxed">
                Une expertise technique cumulée et une maîtrise approfondie des enjeux de transformation dans tous les secteurs d'activité avec un track record de succès mesurable.
              </p>
            </div>

            <div className="text-center group">
              <div className="rounded-full p-8 mb-8 w-fit mx-auto shadow-2xl group-hover:scale-110 transition-transform" style={{
                background: `linear-gradient(135deg, #9B8E56 0%, #FFD700 100%)`
              }}>
                <Icon name="Brain" size={48} className="text-white" />
              </div>
              <h4 className="text-2xl font-bold mb-6">IA Intégrée & Éthique</h4>
              <p className="text-gray-200 leading-relaxed">
                Pionnier dans l'intégration responsable de l'Intelligence Artificielle au service de l'excellence opérationnelle et de la croissance durable avec une approche éthique.
              </p>
            </div>

            <div className="text-center group">
              <div className="rounded-full p-8 mb-8 w-fit mx-auto shadow-2xl group-hover:scale-110 transition-transform" style={{
                background: `linear-gradient(135deg, #D93B34 0%, #9B8E56 100%)`
              }}>
                <Icon name="Handshake" size={48} className="text-white" />
              </div>
              <h4 className="text-2xl font-bold mb-6">Approche Partenariale Unique</h4>
              <p className="text-gray-200 leading-relaxed">
                Relation de confiance et collaboration stratégique pour des résultats durables et une création de valeur partagée avec engagement mutuel de réussite.
              </p>
            </div>
          </div>
        </div>

        {/* Enhanced Next Steps with Increased Background Opacity */}
        <div className="text-center mb-20">
          <h3 className="text-3xl font-bold mb-12">Processus de Collaboration Stratégique</h3>
          <div className="backdrop-blur-sm rounded-3xl p-12 border max-w-6xl mx-auto" style={{
            background: 'rgba(0, 0, 0, 0.35)',
            borderColor: 'rgba(255, 255, 255, 0.4)'
          }}>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
              <div className="space-y-6 group">
                <div className="text-white rounded-full w-16 h-16 flex items-center justify-center font-bold text-2xl mx-auto shadow-lg group-hover:scale-110 transition-transform" style={{
                  background: `linear-gradient(135deg, #D93B34 0%, #9B8E56 100%)`
                }}>
                  1
                </div>
                <h4 className="font-bold text-2xl">Consultation Découverte</h4>
                <p className="text-gray-200 leading-relaxed">
                  Entretien stratégique approfondi pour comprendre votre vision, vos enjeux spécifiques et co-définir les objectifs de transformation
                </p>
              </div>

              <div className="space-y-6 group">
                <div className="text-white rounded-full w-16 h-16 flex items-center justify-center font-bold text-2xl mx-auto shadow-lg group-hover:scale-110 transition-transform" style={{
                  background: `linear-gradient(135deg, #9B8E56 0%, #FFD700 100%)`
                }}>
                  2
                </div>
                <h4 className="font-bold text-2xl">Proposition Personnalisée</h4>
                <p className="text-gray-200 leading-relaxed">
                  Élaboration d'une approche sur-mesure adaptée à votre contexte, vos objectifs et votre écosystème avec roadmap détaillée
                </p>
              </div>

              <div className="space-y-6 group">
                <div className="text-white rounded-full w-16 h-16 flex items-center justify-center font-bold text-2xl mx-auto shadow-lg group-hover:scale-110 transition-transform" style={{
                  background: `linear-gradient(135deg, #FFD700 0%, #D93B34 100%)`
                }}>
                  3
                </div>
                <h4 className="font-bold text-2xl">Partenariat d'Excellence</h4>
                <p className="text-gray-200 leading-relaxed">
                  Lancement de la collaboration stratégique pour concrétiser votre vision avec accompagnement personnalisé et suivi continu
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Contact Options with Increased Background Opacity */}
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-12">Contactez Notre Équipe Vision Stratégique</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                icon: "Phone",
                title: "Consultation Téléphonique",
                description: "Échange direct avec nos experts vision pour une analyse préliminaire",
                action: "Programmer un Appel",
                color: `linear-gradient(135deg, #D93B34 0%, #9B8E56 100%)`
              },
              {
                icon: "Mail",
                title: "Demande Personnalisée",
                description: "Proposition détaillée par email avec diagnostic préliminaire",
                action: "Envoyer une Demande",
                color: `linear-gradient(135deg, #9B8E56 0%, #FFD700 100%)`
              },
              {
                icon: "MapPin",
                title: "Rencontre Physique",
                description: "Atelier vision stratégique dans nos locaux ou sur site",
                action: "Planifier une Visite",
                color: `linear-gradient(135deg, #FFD700 0%, #D93B34 100%)`
              }
            ]?.map((contact, index) => (
              <div key={index} className="backdrop-blur-sm rounded-2xl p-8 border transition-all duration-300 group" style={{
                background: 'rgba(0, 0, 0, 0.35)',
                borderColor: 'rgba(255, 255, 255, 0.4)'
              }}>
                <div className="rounded-2xl p-4 w-fit mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg" style={{
                  background: contact?.color
                }}>
                  <Icon name={contact?.icon} size={40} className="text-white" />
                </div>
                <h4 className="font-bold text-xl mb-4">{contact?.title}</h4>
                <p className="text-gray-200 text-sm mb-6 leading-relaxed">
                  {contact?.description}
                </p>
                <Button
                  variant="outline"
                  size="sm"
                  className="border text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300"
                  style={{
                    borderColor: 'rgba(255, 255, 255, 0.6)',
                    backgroundColor: 'rgba(255, 255, 255, 0.2)'
                  }}
                >
                  {contact?.action}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;